import type { NavigationScreen } from 'app/types/navigation';
import React, { Suspense } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const LazyAllListingsScreen = React.lazy(() => import('./index').then((m) => ({ default: m.AllListingsScreen })));

export const AllListingsScreenLazy: NavigationScreen<'all-listings'> = (props) => (
  <Suspense
    fallback={
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" color={theme.colors['text.brand']} />
      </View>
    }
  >
    <LazyAllListingsScreen {...props} />
  </Suspense>
);
